import React, { memo } from 'react'

interface VideoPreviewProps {
  openViewer?: () => void
  url: string
}
export const VideoPreview = memo(({ openViewer, url }: VideoPreviewProps) => {
  const handleClick = (e: React.MouseEvent<HTMLVideoElement>) => {
    e.stopPropagation()
    e.preventDefault()
    openViewer?.()
  }
  return <video src={url} onClick={handleClick} style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
})
